var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-link"},[_c('img',{attrs:{"src":require("@/assets/img/icons.svg") + "#icon-contact-small","width":"20","height":"20"}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }